let bearerTokenFunction: (() => Promise<string>) | null = null;

export function setGetBearerTokenFunction(func: () => Promise<string>) {
  bearerTokenFunction = func;
}

async function getBearerTokenFunction() {
  if (!bearerTokenFunction) {
    throw new Error("Bearer token function is not set");
  }
  return bearerTokenFunction();
}

export async function fetchGetJSON(url: string) {
  const bearerToken = await getBearerTokenFunction();
  if (!bearerToken) {
    return { error: "Bearer token is not set" };
  }
  try {
    const data = await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
    }).then((res) => res.json());
    if (data.errors) {
      const allErrorMessages = data.errors.reduce(
        (acc: string, error: Error, idx: number) =>
          acc + (acc ? " " : "") + error.message,
        ""
      );
      return { error: allErrorMessages };
    }
    return { data };
  } catch (err) {
    return { error: (err as Error).message };
  }
}

export async function fetchPostJSON(url: string, data?: {}) {
  const bearerToken = await getBearerTokenFunction();
  if (!bearerToken) {
    return { error: "Bearer token is not set" };
  }
  try {
    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(data || {}),
    });

    if (!response.ok) {
      const data = await response.json();
      const allErrorMessages = data.errors.reduce(
        (acc: string, error: Error, idx: number) =>
          acc + (acc ? " " : "") + error.message,
        ""
      );
      return { error: allErrorMessages };
    }
    return { data: "ok" };
  } catch (err) {
    return { error: (err as Error).message };
  }
}

export async function fetchPutJSON(url: string, payload: Record<string, any>) {
  const bearerToken = await getBearerTokenFunction();
  if (!bearerToken) {
    return { error: "Bearer token is not set" };
  }
  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const data = await response.json();
      const allErrorMessages = data.errors.reduce(
        (acc: string, error: Error, idx: number) =>
          acc + (acc ? " " : "") + error.message,
        ""
      );
      return { error: allErrorMessages };
    }
    return { data: "ok" };
  } catch (err) {
    return { error: (err as Error).message };
  }
}
